import classnames from 'classnames';
import styles from './oos-toggle.module.scss';

type Props = {
  checked: boolean;
};

const OosToggle = ({ checked }: Props) => {
  return (
    <span
      className={classnames(styles['oos-toggle'], {
        [styles['oos-toggle--checked']]: checked,
      })}
      aria-hidden="true"
    >
      <span
        className={classnames(styles['oos-toggle__label'], {
          [styles['oos-toggle__label--active']]: checked,
        })}
      >
        Show
      </span>
      <span
        className={classnames(
          styles['oos-toggle__label'],
          styles['oos-toggle__label--right'],
          {
            [styles['oos-toggle__label--active']]: !checked,
          }
        )}
      >
        Hide
      </span>
    </span>
  );
};

export default OosToggle;
